export var PluginType = Object.freeze({
  AUTH_PLUGIN: 'AuthPlugin',
  DASHBOARD_PLUGIN: 'DashboardPlugin',
  ELEMENT_PLUGIN: 'ElementPlugin',
  MIDDLEWARE_PLUGIN: 'MiddlewarePlugin',
  MULTI_PLUGIN: 'MultiPlugin',
  TABLE_PLUGIN: 'TablePlugin',
  THEME_PLUGIN: 'ThemePlugin',
  WIDGET_PLUGIN: 'WidgetPlugin'
});

/**
 * @deprecated Use DashboardPlugin instead
 */

export function isLegacyDashboardPlugin(plugin) {
  return 'DashboardPlugin' in plugin;
}

/**
 * @deprecated Use AuthPlugin instead
 */

export function isLegacyAuthPlugin(plugin) {
  return 'AuthPlugin' in plugin;
}

/**
 * @deprecated Use TablePlugin instead
 */

export function isLegacyTablePlugin(plugin) {
  return 'TablePlugin' in plugin;
}

/**
 * @deprecated Use Plugin instead
 */

export function isLegacyPlugin(plugin) {
  return isLegacyDashboardPlugin(plugin) || isLegacyAuthPlugin(plugin) || isLegacyTablePlugin(plugin);
}

/** @deprecated Use PluginModuleExport instead */

/** @deprecated Use VersionedPluginModuleExport instead */

/**
 * A plugin that will be mounted to the dashboard.
 */

export function isDashboardPlugin(plugin) {
  return 'type' in plugin && plugin.type === PluginType.DASHBOARD_PLUGIN;
}

/**
 * Props passed to middleware components that wrap a base widget.
 * Extends WidgetComponentProps with the wrapped component.
 */

/**
 * Props passed to middleware panel components that wrap a base panel.
 * Extends WidgetPanelProps with the wrapped panel component.
 */

/**
 * A middleware plugin that can wrap and enhance another widget plugin.
 * Middleware plugins are chained together in registration order,
 * with each middleware wrapping the next in the chain.
 *
 * The middleware pattern allows plugins to:
 * - Add additional UI elements around a widget
 * - Intercept and modify props before they reach the wrapped component
 * - Provide additional context or state to the wrapped component
 * - Add menu items or other extensions to the widget
 *
 * A middleware plugin uses its own `PluginType.MIDDLEWARE_PLUGIN` discriminator
 * (rather than being a flagged `WidgetPlugin`) so consumers can cleanly
 * distinguish base widget plugins from middleware via type narrowing.
 */

/**
 * Type guard to check if a plugin is a middleware plugin.
 */
export function isWidgetMiddlewarePlugin(plugin) {
  return 'type' in plugin && plugin.type === PluginType.MIDDLEWARE_PLUGIN;
}

/**
 * Special type of WidgetPlugin that supports opening a widget as a dashboard instead of a panel.
 */

export function isWidgetPlugin(plugin) {
  return 'type' in plugin && plugin.type === PluginType.WIDGET_PLUGIN;
}
export function isWidgetDashboardPlugin(plugin) {
  return isWidgetPlugin(plugin) && 'dashboardTypes' in plugin && plugin.dashboardTypes != null;
}
export function isTablePlugin(plugin) {
  return 'type' in plugin && plugin.type === PluginType.TABLE_PLUGIN;
}

/**
 * Map from auth config keys to their values
 * E.g. Map { AuthHandlers → "io.deephaven.auth.AnonymousAuthenticationHandler" }
 */

/**
 * Props for the auth plugin component to render
 */

export function isAuthPlugin(plugin) {
  return 'type' in plugin && plugin.type === PluginType.AUTH_PLUGIN;
}
/** Type guard to check if given plugin is a `ThemePlugin` */
export function isThemePlugin(plugin) {
  return 'type' in plugin && plugin.type === PluginType.THEME_PLUGIN;
}

/** A mapping of element names to their React components. */

/** An element plugin is used by deephaven.ui to render custom components
 * The mapping contains the element names as keys and the React components as values.
 */

export function isElementPlugin(plugin) {
  return 'type' in plugin && plugin.type === PluginType.ELEMENT_PLUGIN;
}

/**
 * A plugin that contains multiple plugins.
 * When loaded, each plugin in the `plugins` array will be registered individually.
 */

/** Type guard to check if given plugin is a `MultiPlugin` */
export function isMultiPlugin(plugin) {
  return 'type' in plugin && plugin.type === PluginType.MULTI_PLUGIN;
}
export function isPlugin(plugin) {
  return isDashboardPlugin(plugin) || isAuthPlugin(plugin) || isElementPlugin(plugin) || isMultiPlugin(plugin) || isTablePlugin(plugin) || isThemePlugin(plugin) || isWidgetPlugin(plugin) || isWidgetMiddlewarePlugin(plugin);
}
//# sourceMappingURL=PluginTypes.js.map